<template>
  <div class="container">
    <form novalidate @submit.prevent="validateLocalUserData">
      <HeadingOne class="-margin-md">ログインID設定</HeadingOne>

      <ErrorsAlert
        :errors="errors"
        :column-only="true"
        :items="inputItemsCe"
      ></ErrorsAlert>

      <WizardGroup class="-margin-md">
        <MainWizard :active-index="1" type="localid"></MainWizard>
      </WizardGroup>

      <p>
        お客さま情報をご登録させていただきます。以下の項目をご入力のうえ「確認画面へ」を押してください。
      </p>

      <div class="_mb-10">
        <small>※必須の項目は必ずご入力ください。</small>
      </div>

      <section>
        <TableGroup>
          <TableBox>
            <TableBody>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm" class="-entry"
                  >電話番号<small class="moji"
                    >【半角数字※ハイフン不要】</small
                  ></TableHeader
                >
                <TableData :has-error="errors['phone']">
                  <InputGroup :errors="errors" :prop-names="['phone']">
                    <InputgroupAppend>
                      <InputPhone
                        id="phone"
                        :phone="{
                          phone1: localUserData.phone_1,
                          phone2: localUserData.phone_2,
                          phone3: localUserData.phone_3,
                        }"
                        @input="setPhone"
                      ></InputPhone>
                    </InputgroupAppend>
                    <InputLabel id="lastname_kanji">
                      入力例： 09012345678
                    </InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm" class="-entry"
                  >電話番号<small
                    >（確認用）<small class="moji"
                      >【半角数字※ハイフン不要】</small
                    ></small
                  ></TableHeader
                >
                <TableData :has-error="errors['phone_confirmation']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['phone_confirmation']"
                  >
                    <InputgroupAppend>
                      <InputPhone
                        id="phone_confirmation"
                        :phone="{
                          phone1: localUserData.phone_1_confirmation,
                          phone2: localUserData.phone_2_confirmation,
                          phone3: localUserData.phone_3_confirmation,
                        }"
                        @input="setPhoneConfirmation"
                      ></InputPhone>
                    </InputgroupAppend>
                    <InputLabel id="lastname_kanji">
                      入力例： 09012345678
                    </InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm" class="-entry"
                  >メールアドレス<small class="moji"
                    >【半角英数】</small
                  ></TableHeader
                >
                <TableData :has-error="errors['local_mail']">
                  <InputGroup :errors="errors" :prop-names="['local_mail']">
                    <InputLabel id="">
                      メールアドレスは、ログインIDとして使用します。
                    </InputLabel>
                    <InputgroupAppend>
                      <InputItem
                        id="local_mail"
                        v-model="localUserData.local_mail"
                        class="-md"
                        :maxlength="50"
                      ></InputItem>
                    </InputgroupAppend>
                    <InputLabel id=""> 入力例:****@au.com </InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm" class="-entry"
                  >メールアドレス<small
                    >（確認用）<small class="moji">【半角英数】</small></small
                  ></TableHeader
                >
                <TableData :has-error="errors['local_mail_confirmation']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['local_mail_confirmation']"
                  >
                    <InputgroupAppend>
                      <InputItem
                        id="local_mail_confirmation"
                        v-model="localUserData.local_mail_confirmation"
                        class="-md"
                        :maxlength="50"
                      ></InputItem>
                    </InputgroupAppend>
                    <InputLabel id=""> 入力例:****@au.com </InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm" class="-entry"
                  >ログインパスワード<small class="moji"
                    >【半角英数8文字以上】</small
                  ></TableHeader
                >
                <TableData :has-error="errors['local_passwd']">
                  <InputGroup :errors="errors" :prop-names="['local_passwd']">
                    <InputgroupAppend>
                      <InputItem
                        id="local_passwd"
                        v-model="localUserData.local_passwd"
                        class="-sm"
                        type="password"
                        :maxlength="25"
                      ></InputItem>
                    </InputgroupAppend>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm" class="-entry"
                  >ログインパスワード<small
                    >（確認用）<small class="moji"
                      >【半角英数8文字以上】</small
                    ></small
                  ></TableHeader
                >
                <TableData :has-error="errors['local_passwd_confirmation']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['local_passwd_confirmation']"
                  >
                    <InputgroupAppend>
                      <InputItem
                        id="local_passwd_confirmation"
                        v-model="localUserData.local_passwd_confirmation"
                        class="-sm"
                        type="password"
                        :maxlength="25"
                      ></InputItem>
                    </InputgroupAppend>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>
        </TableGroup>
      </section>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-main" @click.prevent="validateLocalUserData">
          確認画面へ
        </BtnMain>
      </BtngroupSingle>
    </form>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import { initCredentials } from "@/utils/Auth";
import { localIdUserDataValidate } from "@/utils/LocalLoginHelper";
import { inputItemsCe } from "@/constants/constant";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import HeadingOne from "@/components/heading/HeadingOne";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import InputGroup from "@/components/input/InputGroup";
import InputItem from "@/components/input/InputItem";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputLabel from "@/components/input/InputLabel";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import InputPhone from "@/components/input/InputPhone";
import ErrorsAlert from "@/components/alert/ErrorsAlert";

export default {
  name: "Ce006",
  components: {
    ErrorsAlert,
    InputPhone,
    BtnMain,
    BtngroupSingle,
    InputLabel,
    InputgroupAppend,
    InputItem,
    InputGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    WizardGroup,
    MainWizard,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "ログインID設定",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ローカルID,認証方法",
    });
  },
  data() {
    return {
      errors: {},
      isDisabled: false,
      localUserData: {
        phone_1: "",
        phone_1_confirmation: "",
        phone_2: "",
        phone_2_confirmation: "",
        phone_3: "",
        phone_3_confirmation: "",
        local_mail: "",
        local_mail_confirmation: "",
        local_passwd: "",
        local_passwd_confirmation: "",
      },
      inputItemsCe: inputItemsCe,
    };
  },
  mounted() {
    if (localStorage.getItem("local_login_data")) {
      this.localUserData = JSON.parse(localStorage.getItem("local_login_data"));
    }
  },
  methods: {
    validateLocalUserData() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            localIdUserDataValidate(this.localUserData)
              .then((res) => {
                if (res.result.check === "OK") {
                  localStorage.setItem(
                    "local_login_data",
                    JSON.stringify(this.localUserData)
                  );
                  this.$router.push({ name: "ce004" });
                } else {
                  this.errors = res.result.error || {};
                  scrollTop();
                  this.isDisabled = false;
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    setPhone(data) {
      this.localUserData.phone_1 = data.phone1;
      this.localUserData.phone_2 = data.phone2;
      this.localUserData.phone_3 = data.phone3;
    },
    setPhoneConfirmation(data) {
      this.localUserData.phone_1_confirmation = data.phone1;
      this.localUserData.phone_2_confirmation = data.phone2;
      this.localUserData.phone_3_confirmation = data.phone3;
    },
  },
};
</script>

<style scoped></style>
